import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { Store } from '@ngxs/store';

import { CustomRolesState } from '../settings/roles/custom.roles.state';
import { checkAllowed } from './utils/authorization-utils';

@Directive({
    selector: '[appIsPermitted]',
    standalone: false,
})
export class IsPermittedDirective {
    private hasView = false;

    constructor(private store: Store, private templateRef: TemplateRef<any>, private viewContainer: ViewContainerRef) {}

    /*
    AND = all modules have to be active
    OR = any module active
    */
    @Input() set appIsPermitted(permissions: Permissions) {
        const allowedActions = JSON.parse(sessionStorage.getItem('allowedActions'));
        if (allowedActions) {
            this.render(checkAllowed(allowedActions, permissions));
            return;
        }

        // The store answers asynchronously on a fresh page, where sessionStorage is not filled in
        // yet. This used to read the result of the subscription on the line after subscribing, so
        // it was still undefined, and the whole branch below was skipped: the element never
        // appeared and nothing ever asked again. Render from inside the callback instead.
        this.store
            .selectOnce(CustomRolesState.AllowedActions)
            .subscribe((actions) => this.render(checkAllowed(actions, permissions)));
    }

    private render(allowed: boolean) {
        if (allowed === undefined || allowed === null) {
            return;
        }
        // Setting the input twice used to add a second embedded view on top of the first rather
        // than replacing it, leaving two copies of whatever it guards -- two three-dot buttons
        // sharing one id, stacked on each other.
        if (allowed === this.hasView) {
            return;
        }
        if (allowed) {
            this.viewContainer.createEmbeddedView(this.templateRef);
        } else {
            this.viewContainer.clear();
        }
        this.hasView = allowed;
    }
}
